import React, { useMemo } from 'react';
import WrapperDataGrid from '@modules/dataGrid/WrapperDataGrid';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-pro';
import { IRouterProps } from '@interfaces/App.interface';
import { CDocument, IConfigComponent } from '@ts/ui-models';
import { generateGlobalColumns, IDataGridConfig } from '@ts/storybook';

interface IDocumentsProps extends IRouterProps {
  configComponent?: IConfigComponent;
  inheritedProps?: any;
}

export const defaultConfigComponent: IConfigComponent = {
  componentId: 'documents',
  aclId: 'taDocument',
  entity: 'document',
  fetchURL: '/api/documents',
  crudURL: '/api/document',
  mainClass: CDocument,
  //where: { ownerUserId: { $notIn: ['system'] } },
};

const Documents = (props: IDocumentsProps) => {
  const { configComponent = defaultConfigComponent } = props;
  const config: IDataGridConfig = {
    columnVisibilityModel: { id: false },
  };
  const getColumns = useMemo((): GridColDef<any>[] => {
    const globalCells = generateGlobalColumns({ ...props, configComponent });
    return [
      globalCells.id(),
      globalCells.name(),
      {
        headerName: 'View',
        field: 'viewDocument',
        width: 100,
        resizable: false,
        valueGetter: (value, row, column) => {
          const tElement = row;
          return tElement?.locator;
        },
        renderCell: (params: GridRenderCellParams) => {
          const tElement = params.row;
          return (
            <div style={{ width: '100%', maxHeight: '100px' }}>
              <img
                src={typeof tElement?.locator === 'string' ? tElement?.locator : tElement?.locator.data}
                style={{ width: '100%', height: 'auto', maxHeight: '75px' }}
              />
            </div>
          );
        },
      },
    ];
  }, [props, configComponent]);

  return (
    <WrapperDataGrid
      configComponent={configComponent}
      dataGridConfig={config}
      columns={getColumns}
      inheritedProps={props.inheritedProps}
    />
  );
};

export default Documents;
